@if (listItems) {
    <div
        class="list"
    >
        <div class="list__filters">
            <ng-content select="[filters]"/>
        </div>
        @if (listItems.data; as data) {
            @defer (on viewport) {
                @if (data.length) {
                    <aside
                        aria-live="polite"
                        [attr.aria-label]="data.length + ' Ergebnisse'"
                    ></aside>
                    <ui-list-items
                        class="list__results"
                        [listItems]="data"
                        [itemContentComponentType]="itemContentComponentType"
                        [attr.aria-hidden]="(isMobile && areFiltersExpanded) ? 'hidden' : null"
                    />
                } @else {
                    <div
                        aria-live="polite"
                        class="list__fallback"
                    >
                        Keine Ergebnisse gefunden.
                    </div>
                }
            } @placeholder (minimum 300ms) {
                <ui-list-items-skeleton
                    aria-live="polite"
                    aria-label="Ergebnisse werden geladen"
                    class="list__skeleton"
                />
            }
        }
        @if (listItems.error?.key === loadingStatus) {
            <ui-list-items-skeleton
                aria-live="polite"
                aria-label="Ergebnisse werden geladen"
                class="list__skeleton"
            />
        }
    </div>
}
